// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0fc947a5","455":"d96456ba","488":"fd595e8e","977":"26f88f69"}[chunkId] + ".chunk.js";
};